import type React from "react";
import { useVisuallyHidden } from "react-aria";

export function VisuallyHidden({ children }: { children: React.ReactNode }) {
  const { visuallyHiddenProps } = useVisuallyHidden();

  return <span {...visuallyHiddenProps}>{children}</span>;
}
